import React from "react";
import "../components/MacWindow.css";
import Draggable from "react-draggable";
import Container from "react-bootstrap/Container";

export default function Internship({ onClose }) {
  return (
    <Draggable handle=".windowheader">
      <div className="draggable-container">
        <div class="window" id="dragable">
          <div class="windowheader" id="dragzone">
            <div class="wrapper">
              <div class="nav-buttons">
                <div class="close" onClick={onClose}></div>
                <div class="minimize"></div>
                <div class="expand"></div>
              </div>
              <div class="title">Internship</div>
            </div>
          </div>

          <div className="body">
            <Container
              style={{ maxHeight: "298px", overflowY: "auto" }}
              id="style-1"
              className="scrollbar"
            >
              <div className="text education">
                <h3>Content Writer Intern, Geeks For Geeks</h3>
                <p>Remote, Jun 2024-present </p>
                <ul>
                  <li>
                    Working as a part time content writer at Geeks For Geeks,
                    focusing on technical articles related to Databases and
                    Python{" "}
                  </li>
                  <li>
                    Authored an article on GitHub Relative link in Markdown and
                    improved the existing article on the platform{" "}
                  </li>
                </ul>
                <h3>Data Analyst Intern, Saint Louis University (USA) </h3>
                <p>Remote, Aug-Sep 2023 </p>
                <ul>
                  <li>
                    Lead a team of 20 members as the Team Lead during my
                    internship period
                  </li>
                  <li>
                    Pioneered a data-driven transformation, this internship
                    involves crafting an analytical solution for Excelerate,
                    driving results with an impressive percentage of precision
                    and accuracy collaborating with my team mates{" "}
                  </li>
                </ul>
                <h3>
                  Student Intern, Future Ready Talent (Sponsored by Microsoft)
                </h3>
                <p>Virtual, Feb-May 2023</p>
                <ul>
                  <li>
                    {" "}
                    Achieved 80% of the internship focused on Azure for
                    developers, attaining extensive knowledge and practice
                    experience with Azure services and developed a project named
                    Cyber Nexus obtained 90% success rate by using a Azure
                    chatbot service
                  </li>
                </ul>
              </div>
            </Container>
          </div>
        </div>
      </div>
    </Draggable>
  );
}
